export default __webpack_public_path__ + "static/media/ic-getgrowing.a2466d9d.svg";